import React from 'react';
import { Link } from 'react-router-dom';
import { content } from '../data/content';
import { Mail, Phone, MapPin, ArrowRight, Twitter, Linkedin,Instagram,Facebook, ArrowUpRight } from 'lucide-react';
import Button from './Button';
import logo from '../assets/Keel_logo_name_in.jpg'

const Footer = () => {
  return (
    <footer className="bg-[#113285] text-white pt-16 pb-12 overflow-hidden relative">
      <div className="container-custom">
        {/* Top Zone */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 mb-12">
          {/* Logo/Brand */}
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6 group cursor-pointer text-center sm:text-left">
            <div className="w-20 h-20 sm:w-24 sm:h-24 bg-white rounded-xl flex items-center justify-center shrink-0 p-2 overflow-hidden">
               <img src={logo} alt="Keel Info Solution" className="w-full h-full object-contain"/>
            </div>
            <div className="flex flex-col justify-center sm:pt-2">
              <p className="text-base sm:text-lg lg:text-xl font-medium opacity-90 leading-relaxed max-w-xs sm:max-w-sm md:max-w-md">
                {content.footer.slogan}
              </p>
            </div>
          </div>

          {/* Slogan */}
          {/* <div className="hidden lg:flex items-center gap-8 flex-1 max-w-xl mx-12">
            <div className="w-px h-12 bg-white/20" />
            <p className="text-xl font-medium opacity-80 leading-relaxed">
              {content.footer.slogan}
            </p>
          </div> */}

          {/* Join Button */}
          {/* <Button className=" text-white  px-8 py-3 rounded-md text-xs font-bold tracking-widest flex items-center gap-2 ">
            {content.footer.ctaJoin} 
          </Button> */}
        </div>

        {/* Divider */}
        <div className="h-px w-full bg-white/10 mb-16" />

        {/* Middle Zone - Link Columns */}
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
          {/* Useful Links Column */}
          <div className="lg:col-span-3 lg:col-start-2">
            <h4 className="text-lg font-bold mb-10 opacity-90">{content.footer.columns[0].title}</h4>
            <ul className="space-y-4">
              {content.footer.columns[0].links.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-white/60 hover:text-[#4DB8E6] transition-colors text-[13px] font-medium">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Column */}
          <div className="lg:col-span-4">
            <h4 className="text-lg font-bold mb-10 opacity-90">{content.footer.columns[1].title}</h4>
            <ul className="space-y-4">
              {content.footer.columns[1].links.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-white/60 hover:text-[#4DB8E6] transition-colors text-[13px] font-medium">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Address Column */}
          <div className="lg:col-span-4 border-l border-white/5 pl-8 lg:pl-12">
            <h4 className="text-lg font-bold mb-10 opacity-90">Our Offices</h4>
            <div className="space-y-8">
              {content.footer.locations.map((loc, index) => (
                <div key={index} className="space-y-2">
                  <h5 className="text-white/90 text-[14px] font-bold mb-2">{loc.title}</h5>
                  <div className="space-y-1">
                    {loc.phones.map((phone, idx) => (
                      <p key={idx} className="text-white/60 text-[13px] font-medium tracking-wide">
                        {phone}
                      </p>
                    ))}
                  </div>
                  {loc.location && (
                    <p className="text-white/60 text-[13px] font-medium leading-relaxed whitespace-pre-line mt-2">
                      {loc.location}
                    </p>
                  )}
                </div>
              ))}
              
              {/* Socials & Copyright */}
              <div className="pt-4 flex flex-col gap-6">
                <div className="flex gap-4 items-center">
                  <a href="https://www.linkedin.com/company/keel-info-solution-private-limited/" target='blank' className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center hover:bg-white/10 transition-all text-white/40 hover:text-white">
                    <Linkedin size={14} fill="currentColor" />
                  </a>
                  <a href="https://www.instagram.com/keelinfosolution/"  target='blank' className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center hover:bg-white/10 transition-all text-white/40 hover:text-white">
                    <Instagram size={14} fill="currentColor" />
                  </a>
                  <a href="https://www.facebook.com/keelinfosolution" target='blank' className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center hover:bg-white/10 transition-all text-white/40 hover:text-white">
                    <Facebook size={14} fill="currentColor" />
                  </a>
                  <a href="https://x.com/Keel_Info_Sol"   target='blank' className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center hover:bg-white/10 transition-all text-white/40 hover:text-white">
                   <svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 640 640"><path fill="rgb(255, 255, 255)" d="M453.2 112L523.8 112L369.6 288.2L551 528L409 528L297.7 382.6L170.5 528L99.8 528L264.7 339.5L90.8 112L236.4 112L336.9 244.9L453.2 112zM428.4 485.8L467.5 485.8L215.1 152L173.1 152L428.4 485.8z"/></svg>
                  </a>
               
                </div>
                <p className="text-white/20 text-[11px] font-bold tracking-widest uppercase">
                  {content.footer.copyright}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
